interface Props {
  label: string;
  onClick?: () => void;
  type?: 'black' | 'orange';
}

const ActionButton = ({ label, onClick, type = 'orange' }: Props) => {
  const orange = 'bg-primary text-white hover:bg-primary-400';
  const black = 'bg-black text-white hover:bg-primary';
  const className = `rounded-full px-7 py-4 text-base font-bold transition-all duration-150 tracking-widest ${type === 'black' ? black : orange}`;

  return (
    <button className={className} onClick={onClick}>
      {label}
    </button>
  );
};

export default ActionButton;
